module.exports = __webpack_public_path__ + "img/7.4c98a8ba.jpg";